import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { MapPin } from "lucide-react";

export const SellerStateAnalytics = ({ format }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/seller/analytics/states").then((r) => setData(r.data)).catch(() => setData({ states: [], other: null }));
  }, []);

  if (!data) return null;
  const rows = data.states || [];
  const max = Math.max(1, ...rows.map((r) => r.revenue));

  return (
    <Card className="p-5" data-testid="seller-state-analytics">
      <h3 className="font-semibold mb-1 flex items-center gap-2"><MapPin className="w-4 h-4 text-primary" /> Orders by Nigerian state</h3>
      <p className="text-xs text-muted-foreground mb-4">See where your buyers are so you can focus your marketing.</p>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center" data-testid="state-analytics-empty">
          No Nigerian orders yet — they'll show up here once buyers start ordering.
        </p>
      ) : (
        <div className="space-y-2.5">
          {rows.slice(0, 12).map((r) => (
            <div key={r.state} data-testid={`state-row-${r.state}`}>
              <div className="flex items-center justify-between text-sm mb-1">
                <span className="font-medium">{r.state} <span className="text-xs text-muted-foreground">· {r.zone}</span></span>
                <span className="text-muted-foreground">{r.orders} order{r.orders !== 1 ? "s" : ""} · <strong className="text-foreground">{format(r.revenue)}</strong></span>
              </div>
              <div className="h-1.5 rounded-full bg-muted overflow-hidden">
                <div className="h-full rounded-full bg-primary" style={{ width: `${Math.max(4, (r.revenue / max) * 100)}%` }} />
              </div>
            </div>
          ))}
          {data.other && data.other.orders > 0 && (
            <p className="text-xs text-muted-foreground pt-1">+ {data.other.orders} order{data.other.orders !== 1 ? "s" : ""} outside Nigeria ({format(data.other.revenue)})</p>
          )}
        </div>
      )}
    </Card>
  );
};
